import React, { Fragment } from 'react'

import { Field, Form, Formik, FormikProps } from 'formik'

import { useMutation, useQuery } from '@apollo/client'
import { Trans } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import Button from 'Root/App/Button'
import Input from 'Root/App/Form/Input'
import Textarea from 'Root/App/Form/Textarea'

import QUERY from './contact-form-prefilled-data.graphql'
import { submit, validationSchema } from './form'
import MUTATION from './send-collection-selling-contact-request.graphql'

interface Props {
  collectionId: string
}

const ContactForm = ({ collectionId }: Props) => {
  const { i18n } = useLingui()
  const { data } = useQuery(QUERY)
  const [mutate, { called }] = useMutation(MUTATION)

  return (
    <Fragment>
      <div className="text-2xl border-b border-gray-300 p-2">
        <Trans>Contattami</Trans>
      </div>
      <Formik
        initialValues={{
          name: data?.user?.name || '',
          email: data?.user?.email || '',
          message: '',
        }}
        onSubmit={submit(mutate, collectionId, i18n)}
        validationSchema={validationSchema}
      >
        {(formikProps: FormikProps<any>) => (
          <Form className="flex flex-col gap-3 p-6">
            <div className="flex flex-col gap-1">
              <label htmlFor="name">
                <Trans>Nome e Cognome</Trans>
              </label>
              <Field as={Input} name="name" id="name" required />
            </div>
            <div className="flex flex-col gap-1">
              <label htmlFor="email">
                <Trans>Email</Trans>
              </label>
              <Field as={Input} name="email" id="email" required />
            </div>
            <div className="flex flex-col gap-1">
              <label htmlFor="message">
                <Trans>Messaggio</Trans>
              </label>
              <Field as={Textarea} id="message" name="message" />
            </div>

            <Button
              disabled={!formikProps.dirty || !formikProps.isValid || called}
              size="L"
              type="submit"
            >
              <Trans>Invia</Trans>
            </Button>
          </Form>
        )}
      </Formik>
    </Fragment>
  )
}

export default ContactForm
